import { User } from '../utilities/types';
import ApiRequest from './request';

export const loginApi = async (username: string, password: string) => {
  return ApiRequest.post('/auth/login', { username, password });
};

export const sendOTP = async (reciever_type: string, value: string) => {
  return ApiRequest.post('/auth/send-otp', {
    reciever_type,
    value,
  });
};

export const verifyOTP = async (
  reciever_type: string,
  value: string,
  otp: string,
  require_reset_key = false,
  login = false
) => {
  return ApiRequest.post('/auth/verify-otp', {
    reciever_type,
    value,
    otp,
    require_reset_key,
    login
  });
};

export const register = async (data: any) => {
  return ApiRequest.post('/auth/register', { ...data });
};

export const getLoggedInuserProfile = async () => {
  return ApiRequest.post('/my-account/profile', {});
};

export const updateProfieApi = async (data: Partial<User>) => {
  return ApiRequest.post('/my-account/update-profile', { ...data });
};

export const changePasswordApi = async (data: Partial<User>) => {
  return ApiRequest.post('/my-account/change-password', { ...data });
};

export const resetPasswordApi = async (data: Partial<User>) => {
  return ApiRequest.post('/auth/reset-password', { ...data });
};

export const myAuctions = async (data: any) => {
  return ApiRequest.post('/my-account/auctions', { ...data });
};

export const enrolledAuctionsAPI = async (data: any) => {
  return ApiRequest.post('/my-account/enrolled-auctions', { ...data });
};

export const nonEnrolledAuctionsAPI = async (data: any) => {
  return ApiRequest.post('/my-account/non-enrolled-auctions', { ...data });
};

export const getCatalogItems = async (data: any) => {
  return ApiRequest.post('/public/items', { ...data });
};

export const getCatalogSubItems = async (data: any) => {
  return ApiRequest.post('/public/sub-items', { ...data });
};

export const auctionList = async (data: any) => {
  return ApiRequest.post('/public/auctions', { ...data });
};

export const createAuction = async (data: any) => {
  return ApiRequest.post('/my-account/create-auction', { ...data });
};

export const getConfigurations = async () => {
  return ApiRequest.post('/masters/configs', {});
};

export const getStatesAPI = async (data: any) => {
  return ApiRequest.post('/masters/states', { ...data });
};

export const getCitiesAPI = async (data: any) => {
  return ApiRequest.post('/masters/cities', { ...data });
};

export const getAuctionDetail = async (data: any) => {
  return ApiRequest.post('/public/auction-detail', { ...data });
};

export const updateAuction = async (data: any) => {
  return ApiRequest.post('/auctions/update', { ...data });
};

export const deleteAuction = async (data: any) => {
  return ApiRequest.post('/auctions/delete', { ...data });
};

export const getBidApplicationDetail = async (data: any) => {
  return ApiRequest.post('/bids/applications/detail', { ...data });
};

export const createBidApplication = async (data: any) => {
  return ApiRequest.post('/bids/applications/create', { ...data });
};

export const placeBidAPi = async (data: any) => {
  return ApiRequest.post('/bids/place-bid', { ...data });
};

export const getItemList = async (data: any) => {
  return ApiRequest.post('/public/items', { ...data });
};

export const getBidList = async (data: any) => {
  return ApiRequest.post('/bids/list', { ...data });
};

export const createAutoBidRequestAPI = async (data: any) => {
  return ApiRequest.post('/bids/create-auto-bid', { ...data });
};

export const updateAutoBidRequestApi = async (data: any) => {
  return ApiRequest.post('/bids/update-auto-bid', { ...data });
};

export const deleteAutoBidRequestApi = async (data: any) => {
  return ApiRequest.post('/bids/delete-auto-bid', { ...data });
};

export const checkAuctionCustomIdAvailiblity = async (data: any) => {
  return ApiRequest.post('/auctions/check-customid-availiblity', { ...data });
};
